export const RateSVG = (props) => (
  <svg height={15} viewBox="0 0 16 15" width={16} fill="currentColor" {...props}>
    <path
      d="m8 1.12977573 2.0191083 4.09116018 4.5148633.65604804-3.2669858 3.18452408.7712307 4.49662017-4.0382165-2.1230161-4.03821651 2.1230161.77123073-4.49662017-3.26698578-3.18452408 4.51486331-.65604804z"
      fillRule="evenodd"
    />
  </svg>
);
